import React, {useEffect, useState} from 'react';

import {getFamilyTypes} from '../DropdownDataProviders' ;

import { renderDropdown, renderDropdownReadOnly} from "../DropdownFunctions";

import SpinnerDiv from "../SpinnerDiv";
import PropTypes from "prop-types";

const DropdownFamilyTypes = (props ) =>
{
    const [ data, setData ] = useState ( { loading: true, items : [] } ) ;

    useEffect(() => {
        getFamilyTypes(false).then (response =>
        {
            setData ( { loading: false, items: response }) ;
        })
    }, []);

    return data.loading === true ? <SpinnerDiv/> :
    (
        props.readOnly === 'readonly' ? renderDropdownReadOnly(props, data) : renderDropdown(props, data)
    )
}

export default DropdownFamilyTypes;

DropdownFamilyTypes.defaultProps =
{
    defaultClassName: 'form-group'
}

DropdownFamilyTypes.propTypes = {
    onChange: PropTypes.func.isRequired
};